const CARREGANDO = (state, payload) => {
  state.carregando = payload;
};

const LISTAR_DADOS_PROVEDORES = (state, payload) => {
  state.listaProvedores = payload.data;
  state.paginacaoProvedores = payload;
};

const LISTAR_DADOS_PROVEDOR = (state, payload) => {
  state.provedor = payload;
};

const LISTAR_WORKFLOWS_PROVEDOR = (state, payload) => {
  state.workflows = payload.data;
  state.paginacaoWorkflows = payload;
};

const SET_FILTRO_DATA = (state, payload) => {
  state.filtroData = payload;
};

export {
  CARREGANDO,
  LISTAR_DADOS_PROVEDORES,
  LISTAR_DADOS_PROVEDOR,
  LISTAR_WORKFLOWS_PROVEDOR,
  SET_FILTRO_DATA
};
